/**
 * Returns true if the user is currently in the admin domain.
 */
export default function isAdminDomain () {
  const { VUE_APP_ENV, VUE_APP_ADMIN_DOMAIN } = process.env
  return (document.location.hostname === VUE_APP_ADMIN_DOMAIN)
    || (VUE_APP_ENV === 'local' && ['localhost','127.0.0.1','[::1]'].includes(document.location.hostname))
}
